webpackJsonp([52],{

/***/ "K1Xq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/section-video-steps_02f90ea4e8a2cb25875f4a5594901644.html";

/***/ }),

/***/ "Th7s":
/***/ (function(module, exports, __webpack_require__) {

var SectionVideoSteps = (function () {
    function SectionVideoSteps() {
    }
    return SectionVideoSteps;
}());
angular.module('animatronApp.sectionVideoSteps', []).component('sectionVideoSteps', {
    bindings: {
        reverse: '<',
        ltTitle: '<',
        description: '<',
        steps: '<',
        buttons: '<'
    },
    controller: SectionVideoSteps,
    templateUrl: __webpack_require__("K1Xq")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/52-28dc41a6a889e793a2e2.min.js